import { DELETE } from "../../../helper/xbi4RestFunctions";

const deleteOrgUserLeave = async (
  org_id: any,
  org_user_id: any,
  leave_id: any,
  leave_type_id:any
) => {
  const path = `/orgs/${org_id}/users/${org_user_id}/leaves/${leave_id}?leave_type_id=${leave_type_id}`;
  return await DELETE(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching modules > ", err);
      return err;
    });
};

export default deleteOrgUserLeave;
